export const EXCEL_FILENAME = "aicarma-domains.xlsx";
export const EXCEL_SHEET_NAME = "Domains";